import script from "./VJoyCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./VJoyCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./VJoyCalendar.vue?vue&type=style&index=0&id=261e5eba&lang=scss"

const __exports__ = script;

export default __exports__